module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-error",
    attrs: {
      "id": "error"
    }
  }, [_c('h1', {
    staticClass: "c-error__code",
    attrs: {
      "id": "error-perspective"
    }
  }, [_vm._v("404")]), _vm._v(" "), _c('div', {
    staticClass: "c-error__copy"
  }, [_c('p', [_vm._v("\"Not all those who wander are lost.\n        Not all that glitters is jewelry.\"")]), _vm._v(" "), _c('p', {
    staticClass: "c-error__copy--credit"
  }, [_vm._v(" - JRR Tolkien")]), _vm._v(" "), _c('router-link', {
    staticClass: "c-btn__lg",
    attrs: {
      "to": "/shop"
    }
  }, [_vm._v("SHOP")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fad3313","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorPage.vue
// module id = 394
// module chunks = 0